import { DriversRestrictionValue } from '../../types'
import type { Texts } from '../useTexts'

export type Option = string[]

export const createValidateCourierFilterDrivers = (
  texts: Texts,
  driverIds: Option[],
  type: uui.domain.rm.RouteManagerUserType,
  restriction: DriversRestrictionValue,
) => {
  const noDriversAdded =
    restriction === 'restricted' && Array.isArray(driverIds) && driverIds.length === 0

  const courierFilterDriversRequiredErrors = {
    id: 'courierFilterDriversErrors',
    message: noDriversAdded ? texts.errors.courierFilter.noDrivers : undefined,
  }

  const courierFilterDriversRequired = type === 'courier' && noDriversAdded

  return {
    [courierFilterDriversRequiredErrors.id]: courierFilterDriversRequired
      ? courierFilterDriversRequiredErrors
      : undefined,
  }
}
